(function () {
  'use strict';
  var allowed = ['method','manufacturer','model','component','result_count','view','name'];
  window.stpTrack = function (event, values) {
    if (!/^stp_[a-z_]+$/.test(event)) return;
    var data = {}; allowed.forEach(function(key){if(values && values[key] !== undefined)data[key]=values[key];});
    document.documentElement.dataset.stpLastEvent = JSON.stringify({event:event,data:data});
    document.dispatchEvent(new CustomEvent('stp:analytics',{detail:{event:event,data:data}}));
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    if(window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function')window.Shopify.analytics.publish(event,data);
    if(Array.isArray(window.dataLayer))window.dataLayer.push(Object.assign({event:event},data));
  };
  document.dispatchEvent(new Event('stp:analytics-ready'));
  if(document.body.classList.contains('template-search')) {
    var p=new URLSearchParams(location.search);
    if(!p.has('stp_make')) {
      var empty=document.querySelector('.search-results--no-results'), products=document.querySelectorAll('.productgrid--item');
      window.stpTrack(products.length?'stp_search_results':'stp_search_no_results',{method:'number',result_count:products.length});
    }
  }
})();
